import { APP_POOL_CONFIG } from '@synergy/config';
import { Box, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PropsWithChildren, ReactElement } from 'react';

type PaymentTermTextProps = {
    isChargingSupplier: boolean;
    paymentTerm: string;
};

const Line = (props: PropsWithChildren): ReactElement | null =>
    props.children ? <Box>-&nbsp;{props.children}</Box> : null;

export const PaymentTermText = ({ isChargingSupplier, paymentTerm }: PaymentTermTextProps): ReactElement => {
    return (
        <Stack>
            <Line>
                {isChargingSupplier && (
                    <FormattedMessage
                        id="app.supplier.paymentTerm.charging"
                        values={{ poolConfigNameShort: APP_POOL_CONFIG['name_short'] }}
                    />
                )}
            </Line>
            <Line>{paymentTerm}</Line>
        </Stack>
    );
};
